import React from "react";
import { Challenge } from "../ChallengesPage";
import Button from "../../Button";
import moment from "moment";
import Popup from "../../common/Popup";
import styled from "styled-components";

const Content = styled.div`
    text-align: center;
`;

const Title = styled.h2`
    color: var(--text-primary) !important;
    font-family: var(--ff-title);
    font-size: 2.5rem !important;
    margin-bottom: 1rem !important;

    body.theme-platinum & {
        color: var(--primary) !important;
        font-weight: 700;
        font-size: 1.5rem !important;
        text-transform: uppercase;
    }

    body.theme-market & {
        color: var(--page-bg) !important;
        font-weight: 900;
    }
`;

const ExpiryDate = styled.p`
    font-size: 0.9rem;
    font-weight: 700;
    margin-top: 2rem;
`;

interface Props {
    challenge: Challenge;
    onClose: () => void;
}

const ChallengeDetail: React.FC<Props> = ({ challenge, onClose }) => {
    const date = moment(challenge.expiry).format('DD [de] MMMM [de] YYYY');

    return (
        <Popup isOpen={true} onClose={onClose}>
            <Content>
                <Title>{challenge.name}</Title>

                <p>{challenge.description}</p>
                
                <ExpiryDate>Vigencia al {date}.</ExpiryDate>
                <Button onClick={onClose}>Continuar</Button>
            </Content>
        </Popup>
    );
};

export default ChallengeDetail;